import { render, staticRenderFns } from "./payment-providers.vue?vue&type=template&id=5a86ba68"
import script from "./payment-providers.vue?vue&type=script&lang=js"
export * from "./payment-providers.vue?vue&type=script&lang=js"
import style0 from "./payment-providers.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports